import React, { useEffect, useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import { Toast } from '../Toast/Toast';
import { updateActivity } from '@hobs/actions/serviceRequests';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ShortId from 'shortid';
import Loader from '../Loader/Loader';
import { Field } from 'formik';

import './activityDropdown.scss';
import InputLabel from '../InputLabel/InputLabel';

const ActivityDropdown = ({
  t,
  updateActivity,
  indicationMessage,
  disabled,
  sr,
  activities,
  value,
  activityInForm,
  setFieldValue,
  fieldName,
  name
}) => {
  const [dropdownValue, setDropdownValue] = useState(value);
  const [isLoading, setIsLoading] = useState(false);
  const [activityList, setActivityList] = useState([]);

  useEffect(() => {
    setDropdownValue(value);
  }, [value]);

  useEffect(() => {
    if (activities === undefined || activities === null) {
      setActivityList([]);
      return;
    }
    setActivityList(activities);
  }, []);

  const hasActivities = () => {
    return activityList.length > 0;
  };

  const canEditActivity = () => {
    if (sr.canEditActivity == undefined) {
      return !disabled;
    }
    return sr.canEditActivity;
  };

  const changeActivity = event => {
    if (sr.canEditActivity == undefined) {
      return;
    }
    setIsLoading(true);

    const activityId = event.target.value;
    setDropdownValue(activityId);

    updateActivity(sr.statementOfRequirementId, sr.serviceRequestId, {
      activityId: activityId
    }).then(() => {
      setIsLoading(false);
      Toast.success(t('Activity updated successfully'));
    });
  };

  return (
    <>
      {activityInForm ? (
        <Field
          label={t('Activity')}
          setFieldValue={setFieldValue}
          name={`${fieldName ? fieldName : 'activityId'}`}
          component={Dropdown}
          disabled={!canEditActivity()}
          defaultValue={ShortId.generate()}
          indicationMessage={indicationMessage}
        >
          {!canEditActivity() && !sr.activityId && (
            <option value="">{t('No activity selected')}</option>
          )}
          {!canEditActivity() && sr.activityId && (
            <option value={sr.activityId}>{t(sr.activityName)}</option>
          )}
          {canEditActivity() &&
            []
              .concat(
                [
                  {
                    name: t('No activity selected'),
                    activityId: ''
                  }
                ],
                activities
              )
              .map(activity => (
                <option key={ShortId.generate()} value={activity.activityId}>
                  {activity.name}
                </option>
              ))}
        </Field>
      ) : (
        <div className="activity-dropdown">
          {isLoading && (
            <div className="activity-dropdown--loader">
              <Loader />
            </div>
          )}
          <InputLabel>{t('Activity')}</InputLabel>
          {hasActivities() ? (
            <Dropdown
              value={dropdownValue}
              indicationMessage={indicationMessage}
              onChange={changeActivity}
              disabled={!canEditActivity() || isLoading}
            >
              {!canEditActivity() && !sr.activityId && (
                <option value="">{t('No activity selected')}</option>
              )}
              {!canEditActivity() && sr.activityId && (
                <option value={sr.activityId}>{t(sr.activityName)}</option>
              )}
              {canEditActivity() &&
                []
                  .concat(
                    [
                      {
                        name: t('No activity selected'),
                        activityId: ''
                      }
                    ],
                    activities
                  )
                  .map(activity => (
                    <option
                      key={ShortId.generate()}
                      value={activity.activityId}
                    >
                      {activity.name}
                    </option>
                  ))}
            </Dropdown>
          ) : (
            <>
              <br /> {value && name ? name : '-'}
            </>
          )}
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = {
  updateActivity
};

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(ActivityDropdown));
